export const products = {
  categories: [
    {
      name: 'AI / machine learning',
      translationId: 'ai',
      description:
        'Use AI on IBM Cloud or build your own machine learning models',
      icon: 'product-ai',
      link: '/cloud/redhat',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'InstructLab on IBM Cloud',
          longDescription: 'Deploy customed AI models as a service',
          url: '/cloud/redhat',
          pricingUrl: '/products/watsonx-assistant/pricing',
          translationId: 'instructLab',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],

          external: false,
        },
        {
          name: 'Red Hat OpenShift AI on IBM Cloud',
          longDescription:
            'Scalable AI and ML development platform for Enterprises',
          url: '/cloud/redhat',
          pricingUrl: '/products/watsonx-assistant/pricing',
          translationId: 'redHat',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'RHEL AI',
          longDescription:
            'Foundation model to consistently power AI enterprise applications',
          url: '/cloud/redhat',
          pricingUrl: '/products/watsonx-assistant/pricing',
          translationId: 'rhel',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Assistant',
          longDescription: 'Virtual agents customizable to any domain',
          url: '/products/watsonx-assistant',
          pricingUrl: '/products/watsonx-assistant/pricing',
          translationId: 'watsonAssistant',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Discovery',
          longDescription:
            'Search and analytics engine that adapts to custom domains',
          url: '/products/watson-discovery',
          pricingUrl: '/products/watson-discovery/pricing',
          translationId: 'watsonDiscovery',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Knowledge Catalog',
          longDescription: 'SaaS for AI data management',
          url: '/products/watsonx-data-intelligence/governance-catalog',
          pricingUrl: '/products/watson-knowledge-catalog/pricing',
          translationId: 'watsonCatalog',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Knowledge Studio',
          longDescription:
            'Visual interface to teach Watson domain-specific knowledge',
          url: '/products/watson-discovery',
          pricingUrl: '/products/watson-discovery/pricing',
          translationId: 'watsonKnowledgeStudio',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Language Translator',
          longDescription: 'API for translation with domain-specific models',
          url: '/products/watsonx-orchestrate',
          pricingUrl: '/products/natural-language-processing/pricing',
          translationId: 'watsonLanguageTranslator',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Natural Language Classifier',
          longDescription: 'Visual tool and API for text classification',
          url: '/products/natural-language-understanding',
          pricingUrl: '/products/natural-language-understanding/pricing',
          translationId: 'watsonLanguageClassifier',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Natural Language Understanding',
          longDescription: 'API for text analysis and metadata extraction',
          url: '/products/natural-language-understanding',
          pricingUrl: '/products/natural-language-understanding/pricing',
          translationId: 'watsonLanguageUnderstanding',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Speech to Text',
          longDescription:
            'API for real-time speech recognition and transcription',
          url: '/products/speech-to-text',
          pricingUrl: '/products/speech-to-text/pricing',
          translationId: 'watsonSpeechToText',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Studio',
          longDescription: 'IDE to build, run and manage AI models',
          url: '/products/watson-studio',
          pricingUrl: '/products/watson-studio/pricing',
          translationId: 'watsonStudio',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Watson Text to Speech',
          longDescription: 'API for real-time text to speech conversion',
          url: '/products/text-to-speech',
          pricingUrl: '/products/text-to-speech/pricing',
          translationId: 'watsonTextToSpeech',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Analytics',
      translationId: 'analytics',
      description: 'Aggregate and analyze large datasets',
      icon: 'analytics',
      link: '/cloud/analytics',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud Pak for Data',
          longDescription:
            'Platform that modernizes how businesses manage data to infuse AI.',
          url: '/products/cloud-pak-for-data',
          pricingUrl: null,
          translationId: 'pakData',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Analytics Engine',
          longDescription:
            'PaaS to build analytics applications on Apache Spark and Hadoop ',
          url: '/products/analytics-engine',
          pricingUrl: '/cloud/analytics-engine/pricing',
          translationId: 'analyticsEngine',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Db2 Warehouse on Cloud',
          longDescription: 'Managed data warehouse on IBM Cloud or AWS',
          url: '/cloud/db2-warehouse-on-cloud',
          pricingUrl: '/cloud/db2-warehouse-on-cloud/pricing',
          translationId: 'db2Warehouse',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM InfoSphere® Information Server on Cloud',
          longDescription:
            'Data integration suite for ETL, governance and anlaysis',
          url: '/products/information-server',
          pricingUrl: '/products/information-server/pricing',
          translationId: 'infosphere',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Master Data Management on Cloud',
          longDescription: 'Managed master data storage',
          url: '/master-data-management',
          pricingUrl: '/master-data-management/pricing',
          translationId: 'mdm',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Automation',
      translationId: 'automation',
      description:
        'Automate workflows from IT operations to business processes',
      icon: 'automation',
      link: '/automation',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud Pak for Business Automation',
          longDescription: 'Operations management software with AI insights',
          url: '/products/cloud-pak-for-business-automation',
          pricingUrl: '/products/cloud-pak-for-business-automation/pricing',
          translationId: 'cloudpakba',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Pak for Integration',
          longDescription: 'Tools to connect all of your apps, data and events',
          url: '/products/cloud-pak-for-integration',
          pricingUrl: '/products/cloud-pak-for-integration/pricing',
          translationId: 'pakIntegration',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Pak for Network Automation',
          longDescription: 'Management software for telco network operations',
          url: '/products/cloud-pak-for-network-automation',
          pricingUrl: '/products/cloud-pak-for-network-automation/pricing',
          translationId: 'cloudpakna',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Pak for AIOps',
          longDescription:
            'DevOps management tool with AI analysis and recommendations',
          url: '/products/cloud-pak-for-aiops',
          pricingUrl: '/products/cloud-pak-for-aiops/pricing',
          translationId: 'watsonAiops',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Turbonomic',
          longDescription:
            'Software to automate application resource management and optimize costs',
          url: '/products/turbonomic',
          pricingUrl: null,
          translationId: 'turbonomic',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Blockchain',
      translationId: 'blockchain',
      description: 'Build applications on an immutable blockchain ledger',
      icon: 'blockchain',
      link: '',
      products: [
        {
          name: 'IBM Blockchain Platform',
          longDescription: 'Blockchain SDK based on Hyperledger Fabric',
          url: 'https://www.ibm.com/mysupport/s/topic/0TO0z000000YqidGAC/blockchain-platform?language=en_US',
          pricingUrl:
            '/products/blockchain-platform-hyperledger-fabric/pricing',
          translationId: 'blockchainPlatform',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Compute',
      translationId: 'compute',
      description: 'Run workloads on cloud infrastrcture',
      icon: 'compute',
      link: '/cloud/compute',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'Dizzion Managed DaaS on IBM Cloud',
          longDescription: 'Virtual desktops, in the cloud and managed',
          url: '/cloud/dizzion',
          pricingUrl: '/cloud/dizzion/pricing',
          translationId: 'horizon',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Bare Metal Servers',
          longDescription: 'Dedicated hardware for maximum performance',
          url: '/products/bare-metal-servers',
          pricingUrl: 'https://cloud.ibm.com/gen1/infrastructure/provision/bm',
          translationId: 'bareMetal',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Code Engine',
          longDescription: 'Serverless container hosting platform as a service',
          url: '/products/code-engine',
          pricingUrl: '/cloud/code-engine/pricing',
          translationId: 'codeEngine',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud for VMware Solutions',
          longDescription: 'Hosting for virtualized workloads',
          url: '/products/vmware',
          pricingUrl: '/cloud/vmware/pricing',
          translationId: 'vmwareSolutions',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Virtual Server for VPC',
          longDescription: 'Virtual servers with enhanced network security',
          url: '/products/virtual-servers ',
          pricingUrl: '/cloud/virtual-servers/pricing',
          translationId: 'vpc',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud VPS Hosting',
          longDescription: 'Easily manage fast-moving workloads.',
          url: '/cloud/vps',
          pricingUrl: '/cloud/vps',
          translationId: 'vpsHosting',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'GPUs on IBM Cloud',
          longDescription:
            'Accelerate and securely scale gen AI and traditional AI workloads',
          url: 'https://www.ibm.com/cloud/gpu',
          pricingUrl: 'https://www.ibm.com/cloud/gpu',
          translationId: 'virtualServers',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Hyper Protect Virtual Servers',
          longDescription: 'Virtual servers for workloads with sensitive data',
          url: '/products/hyper-protect-virtual-servers/cloud',
          pricingUrl: '/cloud/hyper-protect-virtual-servers/pricing',
          translationId: 'hyperProtectVirtualServers',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Power Systems Virtual Servers',
          longDescription: 'Virtual servers with IBM POWER processors',
          url: '/products/power-virtual-server',
          pricingUrl:
            'https://cloud.ibm.com/catalog/services/power-systems-virtual-server',
          translationId: 'powerVirtualServer',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM WebSphere Application Server on Cloud',
          longDescription: 'Runtime and SDK for Java applications',
          url: '/products/websphere-application-server',
          pricingUrl: '/cloud/websphere-application-server/pricing',
          translationId: 'websphere',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Containers',
      translationId: 'containers',
      description: 'Deploy applications consistently across environments',
      icon: 'containers.svg',
      link: '/cloud/containers',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud Container registry',
          longDescription: 'SaaS for container storage and management',
          url: '/products/container-registry',
          pricingUrl: '/products/container-registry',
          translationId: 'containerRegistry',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Code Engine',
          longDescription: 'Serverless container hosting platform as a service',
          url: '/products/code-engine',
          pricingUrl: '/products/code-engine/pricing',
          translationId: 'codeengine',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Kubernetes Service',
          longDescription:
            'Container hosting with self-healing and horizontal scaling',
          url: '/products/kubernetes-service',
          pricingUrl: '/cloud/kubernetes-service/pricing',
          translationId: 'kubernetes',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Istio on IBM Cloud',
          longDescription:
            'A service mesh for microservices in Kubernetes clusters',
          url: '/products/istio',
          pricingUrl: null,
          translationId: 'istio',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Red Hat® OpenShift® on IBM Cloud',
          longDescription:
            'Container platform to build, deploy, and scale critical applications',
          url: '/products/openshift',
          pricingUrl: '/cloud/openshift/pricing',
          translationId: 'openShift',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Databases',
      translationId: 'databases',
      description: 'Store, query and analyze structured data',
      icon: 'databases',
      link: '/cloud/databases',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud Databases for Elasticsearch',
          longDescription: 'Managed JSON document store for full-text search',
          url: '/products/databases-for-elasticsearch',
          pricingUrl: '/products/databases-for-elasticsearch',
          translationId: 'databasesForElasticsearch',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for EnterpriseDB',
          longDescription: 'Managed SQL database',
          url: '/products/cloud-databases',
          pricingUrl: '/products/databases-for-enterprisedb',
          translationId: 'databasesForEnterprisedb',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for etcd',
          longDescription: 'Managed distributed key-value store',
          url: '/products/databases-for-etcd',
          pricingUrl: '/products/databases-for-etcd',
          translationId: 'databasesForEtcd',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for MongoDB',
          longDescription: 'Managed NoSQL JSON document store',
          url: '/products/databases-for-mongodb',
          pricingUrl: '/products/databases-for-mongodb/pricing',
          translationId: 'databasesForMongodb',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for MySQL',
          longDescription:
            'A fully managed MySQL relational database service. Deploy and scale effortlessly to drive innovation.',
          url: '/products/databases-for-mysql',
          pricingUrl: '/products/databases-for-mysql',
          translationId: 'databasesForMysql',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for PostgreSQL',
          longDescription: 'Managed SQL database',
          url: '/products/databases-for-postgresql',
          pricingUrl: '/products/databases-for-postgresql',
          translationId: 'databasesForPostgresql',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Databases for Redis',
          longDescription: 'Managed in-memory key value store',
          url: '/products/databases-for-redis',
          pricingUrl: '/products/databases-for-redis',
          translationId: 'databasesForRedis',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloudant®',
          longDescription:
            'Managed PCI-compliant JSON document store on CouchDB',
          url: '/products/cloudant',
          pricingUrl: '/products/cloudant/pricing',
          translationId: 'cloudant',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Db2 Warehouse',
          longDescription: 'Managed data warehouse on IBM Cloud or AWS',
          url: '/products/db2-warehouse',
          pricingUrl: '/products/db2-warehouse',
          translationId: 'db2Warehouse',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Db2® on Cloud',
          longDescription: 'Managed SQL database',
          url: '/products/db2-database ',
          pricingUrl: '/products/db2-database ',
          translationId: 'db2',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Informix® on Cloud',
          longDescription:
            'Managed DB for time series, spatial, NoSQL and SQL data',
          url: '/products/informix',
          pricingUrl: '/products/informix/pricing',
          translationId: 'informix',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Developer tools',
      translationId: 'developerTools',
      description: 'Manage infrastructure, environments and deployments',
      icon: 'developer-tools',
      link: '/cloud/devops',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud App Configuration',
          longDescription:
            'SDK, dashboard and API for application feature management',
          url: 'https://cloud.ibm.com/catalog/services/app-configuration#about',
          pricingUrl: null,
          translationId: 'appConfiguration',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Continuous Delivery',
          longDescription:
            'UI and CLI based DevOps workflows based on Tekton Pipelines',
          url: '/cloud/continuous-delivery',
          pricingUrl: '/cloud/continuous-delivery/pricing',
          translationId: 'continuousDelivery',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Messages for RabbitMQ',
          longDescription: 'Managed message broker',
          url: '/cloud/messages-for-rabbitmq',
          pricingUrl: '/cloud/messages-for-rabbitmq/pricing',
          translationId: 'messagesForRabbitmq',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Schematics',
          longDescription:
            'Managed service to provision resources with terraform templates',
          url: '/cloud/schematics',
          pricingUrl: null,
          translationId: 'schematics',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Tekton on IBM Cloud',
          longDescription: 'Kubernetes-native CI and CD pipelines',
          url: '/products/tekton ',
          pricingUrl: null,
          translationId: 'tekton',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Integration',
      translationId: 'integration',
      description:
        'Integrate your apps through APIs, messaging and networking tools',
      icon: 'integration',
      link: '/cloud/integration',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM API Connect®',
          longDescription:
            'A toolkit to rapidly create, secure and manage APIs',
          url: '/products/api-connect',
          pricingUrl: '/products/api-connect/pricing',
          translationId: 'apiConnect',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM App Connect',
          longDescription: 'Codeless connectors for your data, apps and APIs',
          url: '/products/app-connect',
          pricingUrl: '/products/app-connect/pricing',
          translationId: 'appConnect',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Aspera® on Cloud',
          longDescription: 'UI and CLI to rapidly move large files',
          url: '/cloud/aspera',
          pricingUrl: '/cloud/aspera/pricing',
          translationId: 'aspera',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        /*
        {
         name: 'IBM Cloud for Skytap Solutions',
         longDescription:
           'Virtualization for x86, AIX, System i and Power applications',
         url: '/cloud/skytap',
         pricingUrl: null,
         translationId: 'skytap',
         localeWhitelist: [
           'de-de',
           'en-us',
           'es-es',
           'fr-fr',
           'it-it',
           'ja-jp',
           'ko-kr',
           'pt-br',
           'zh-cn'
         ],
         external: false
        }
        */
        {
          name: 'IBM Cloud Pak for Integration',
          longDescription: 'Tools to connect all of your apps, data and events',
          url: '/products/cloud-pak-for-integration',
          pricingUrl: '/products/cloud-pak-for-integration/pricing',
          translationId: 'pakIntegration',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Event Streams',
          longDescription: 'PaaS stream processing based on Apache Kafka',
          url: '/products/event-streams',
          pricingUrl: null,
          translationId: 'eventStreams',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Lift',
          longDescription: 'Toolkit to migrate on-premises data to the cloud',
          url: '/cloud/lift',
          pricingUrl: null,
          translationId: 'lift',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM MQ on Cloud',
          longDescription: 'Managed message broker',
          url: '/products/mq/saas',
          pricingUrl: '/products/mq/cloud /pricing',
          translationId: 'cloudMq',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Internet of things',
      translationId: 'iot',
      description: 'Connect and manage edge devices',
      icon: 'internet-of-things',
      link: '/cloud/internet-of-things',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Edge Application Manager',
          longDescription:
            'An autonomous management platform for edge computing',
          url: '/edge-computing',
          pricingUrl: null,
          translationId: 'edgeComputing',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Maximo Application Suite: Remote monitoring',
          longDescription:
            'Predict and prevent issues with advanced AI-powered remote monitoring and computer vision for assets and operations.',
          url: '/products/maximo/asset-performance-management',
          pricingUrl: null,
          translationId: 'iotPlatform',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Logging and monitoring',
      translationId: 'loggingAndMonitoring',
      description: 'Log and analyze activity in your infrastructure',
      icon: 'logging-and-monitoring.svg',
      link: '',
      products: [
        {
          name: 'IBM Cloud Logs',
          longDescription: 'Log and analyze activity in your infrastructure',
          url: '/products/cloud-logs',
          pricingUrl: '/products/cloud-logs',
          translationId: 'ibmcloudlogs',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Monitoring',
          longDescription: 'Managed dashboard for Kubernetes devops',
          url: '/products/cloud-monitoring',
          pricingUrl:
            'https://cloud.ibm.com/catalog/services/ibm-cloud-monitoring',
          translationId: 'sysdig',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Logs',
          longDescription:
            'Gain logs observability with IBM Cloud Logs to help improve infrastructure and app performance',
          url: 'https://www.ibm.com/products/cloud-pak-for-aiops',
          pricingUrl: 'https://www.ibm.com/products/cloud-pak-for-aiops',
          translationId: 'watsonAiops',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Networking',
      translationId: 'network',
      description: 'Run and manage public, private and virtual networks',
      icon: 'networking',
      link: '/cloud/network',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'Domain name services',
          longDescription: 'Public and private DNS and domain registration',
          url: '/products/dns',
          pricingUrl: '/products/dns/pricing',
          translationId: 'dns',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Direct Link',
          longDescription:
            'Physical or virtual private connections to IBM Cloud',
          url: '/products/direct-link',
          pricingUrl:
            'https://cloud.ibm.com/docs/infrastructure/direct-link?topic=direct-link-pricing-for-ibm-cloud-direct-link#pricing-for-ibm-cloud-direct-link',
          translationId: 'directLink',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Internet Services',
          longDescription: 'Load balancing and CDN solution',
          url: '/products/cloud-internet-services ',
          pricingUrl:
            'https://cloud.ibm.com/catalog/services/internet-services',
          translationId: 'cloudInternetServices',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Load balancer',
          longDescription: 'Traffic flow management for cloud applications',
          url: '/products/load-balancer ',
          pricingUrl:
            'https://cloud.ibm.com/docs/infrastructure/loadbalancer-service?topic=loadbalancer-service-ibm-cloud-load-balancer-pricing',
          translationId: 'loadBalancer',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Gateway appliances',
          longDescription:
            'Physical and virtual routers, firewalls, VPNs and more',
          url: '/products/network-appliances ',
          pricingUrl: null,
          translationId: 'networkAppliances',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud network security',
          longDescription:
            'Hardware and software firewalls, network security group management',
          url: '/products/network-security',
          pricingUrl: null,
          translationId: 'loudNetworkSecurity',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Quantum',
      translationId: 'quantum',
      description: 'Run code on real quantum systems using a full-stack SDK',
      icon: 'quantum.svg',
      link: 'https://cloud.ibm.com/quantum',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'Qiskit',
          longDescription: 'Python SDK for open-source quantum development',
          url: 'https://www.ibm.com/quantum/qiskit',
          pricingUrl: null,
          translationId: 'qiskit',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: true,
        },
        {
          name: 'Qiskit Runtime',
          longDescription:
            'Low-latency execution environment for quantum programs',
          url: 'https://cloud.ibm.com/catalog/services/quantum-computing',
          pricingUrl: null,
          translationId: 'qiskitRuntime',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Security',
      translationId: 'security',
      description:
        'Secure your cloud resources and simplify regulatory compliance',
      icon: 'security',
      link: '/cloud/security',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud App ID',
          longDescription:
            'Compliant authentication, authorization and user data SaaS',
          url: '/products/app-id',
          pricingUrl: 'https://cloud.ibm.com/catalog/services/app-id',
          translationId: 'appId',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Hardware Security Module 7.0',
          longDescription:
            'Tamper-resistant hardware to store and process cryptographic keys',
          url: '/products/hardware-security-module',
          pricingUrl: 'https://cloud.ibm.com/gen1/infrastructure/provision/hsm',
          translationId: 'securityModule',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Pak for Security',
          longDescription:
            'Security auditing, reporting, analysis and governance',
          url: '/products/cloud-pak-for-security',
          pricingUrl: '/products/cloud-pak-for-security/pricing',
          translationId: 'pakSecurity',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Secrets Manager',
          longDescription:
            'Single-tenant, dedicated instance to manage your secrets',
          url: '/products/secrets-manager',
          pricingUrl: 'https://cloud.ibm.com/catalog/services/secrets-manager',
          translationId: 'secretsManager',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Security and Compliance Center',
          longDescription:
            'SaaS to define and audit the compliance posture of your cloud',
          url: '/products/security-and-compliance-center',
          pricingUrl: null,
          translationId: 'compianceCenter',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Hyper Protect Crypto Services',
          longDescription:
            'Cloud hardware to store and process cryptographic keys',
          url: '/products/hyper-protect-crypto',
          pricingUrl: '/cloud/hyper-protect-crypto/pricing',
          translationId: 'hyperProtectCryptoServices',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Key Protect for IBM Cloud',
          longDescription:
            'Encryption key provisioning and storage for IBM Cloud apps',
          url: '/products/key-protect',
          pricingUrl: 'https://cloud.ibm.com/catalog/services/key-protect',
          translationId: 'keyProtect',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'Network security',
          longDescription:
            'Hardware and software firewalls, network security group management',
          url: '/products/network-security ',
          pricingUrl: null,
          translationId: 'loudNetworkSecurity',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'SSL certificates',
          longDescription: 'Certificates for cloud resources',
          url: '/cloud/ssl-certificates',
          pricingUrl: null,
          translationId: 'sslCertificates',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
    {
      name: 'Storage',
      translationId: 'storage',
      description: 'Store, migrate and back up your data',
      icon: 'storage',
      link: '/cloud/storage',
      localeWhitelist: [
        'de-de',
        'en-us',
        'es-es',
        'fr-fr',
        'it-it',
        'ja-jp',
        'ko-kr',
        'pt-br',
        'zh-cn',
      ],
      products: [
        {
          name: 'IBM Cloud Backup',
          longDescription:
            'Fully encrypted backup and recovery across multiple datacenters ',
          url: '/products/backup',
          pricingUrl: '/cloud/backup/pricing',
          translationId: 'backup',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Block Storage',
          longDescription:
            'The lowest latency, highest redundancy data storage option',
          url: '/products/block-storage',
          pricingUrl: '/cloud/block-storage/pricing',
          translationId: 'blockStorage',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud File Storage',
          longDescription:
            'The simplest solution for data organized into files and folders',
          url: '/products/file-storage',
          pricingUrl: '/cloud/file-storage/pricing',
          translationId: 'fileStorage',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
        {
          name: 'IBM Cloud Object Storage',
          longDescription:
            'Unstructured cloud data storage with an API frontend',
          url: '/products/cloud-object-storage',
          pricingUrl: '/cloud/object-storage/pricing',
          translationId: 'objectStorage',
          localeWhitelist: [
            'de-de',
            'en-us',
            'es-es',
            'fr-fr',
            'it-it',
            'ja-jp',
            'ko-kr',
            'pt-br',
            'zh-cn',
          ],
          external: false,
        },
      ],
    },
  ],
};
